import fieldMixin from '@phoenix/mixins/fieldMixin';

export default {
  mixins: [fieldMixin],

  props: {
    isSgphx: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    fieldClasses() {
      if (this.isSgphx) {
        return [
          'sgphx-field',
          this.fieldClass,
          {
            'sgphx-field--invalid': this.isInvalid,
            'sgphx-w-1/2': this.halfWidth,
          },
        ];
      }

      return [
        'field',
        this.fieldClass,
        {
          'field--invalid': this.isInvalid,
          'w-1/2': this.halfWidth,
        },
      ];
    },
  },
};
